export default {
    install(Vue) {
        function toUpperCase(e) {
            const el = e.target;
            if (
                !el ||
                (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') ||
                (el.tagName === 'INPUT' && el.type === 'file')
            ) return;

            const upper = el.value.toLocaleUpperCase('es');
            if(upper !== el.value) {
                const {  selectionStart, selectionEnd } = el;
                el.value = upper;
                el.dispatchEvent(new Event('input', { bubbles: true }));
                el.setSelectionRange(selectionStart, selectionEnd);
            }
        }
        document.addEventListener('input', toUpperCase, true);
    }
}